import styled from "styled-components"

export const Title = styled.h1`
  text-align: ${({align}) => align ? align : "center"};
  font-size: 2rem;
  font-family: InterBold;
  color: ${({ theme,color }) => color ? color : theme.colors.headlineWhite};
`
